import React from 'react'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import MuiTableRow from '@material-ui/core/TableRow'
import IconButton from '@material-ui/core/IconButton'
import url from 'front-end-core/core/url'
import { MW_DEAL_DETAILS } from 'constants/controllers'
import { URL_DOWNLOAD_DEAL_ZIP, URL_MW_DEAL_DOCUMENT } from 'constants/urls'
import { DISPLAY_DATE_FORMAT } from 'constants/locale'
import selectAolName from 'redux/selectors/selectAolName'
import { LayoutHeader, HeaderAction } from 'components/dealwatch/Layout'
import Icon from 'components/shared/Icon'
import TealToolTip from 'components/TealToolTip'
import TableCell from 'components/dealwatch/TableCell'
import Table from './Table'

const Document = ({ document, downloadUrl, dealId, onClickDownload }) => {
  const { dateReleased, filename, id: docId } = document
  const aol = useSelector(selectAolName)

  return (
    <MuiTableRow className='w-100'>
      <TableCell cxNames='pv3'>
        {document.documentType.displayName}
      </TableCell>
      <TableCell cxNames='pv3'>
        {dayjs(dateReleased).format(DISPLAY_DATE_FORMAT)}
      </TableCell>
      <TableCell cxNames='pv3'>
        <a className='pointer underline' href={url(MW_DEAL_DETAILS, { dealId, aol }, { docId })}>
          {filename}
        </a>
      </TableCell>
      <TableCell cxNames='pv3'>
        <TealToolTip title='Download PDF' placement='top' leaveDelay={300}>
          <div
            className='mr2 pointer underline'
            onClick={() => {
              onClickDownload(
                downloadUrl(URL_MW_DEAL_DOCUMENT, { dealId, docId }),
                filename
              )
            }}
          >
            <IconButton size='small' classes={{ sizeSmall: 'pa3' }}>
              <Icon name='icon-download' className='w7 mt1 dark-sea-green-2' />
            </IconButton>
          </div>
        </TealToolTip>
      </TableCell>
    </MuiTableRow>
  )
}

const DealDocuments = ({ documents, downloadUrl, dealId, onClickDownload }) => (
  <>
    <LayoutHeader title='Documents' spacing={0} cxNames='pv1 mb4'>
      <HeaderAction
        icon='icon-download'
        description='Download deal documents in .zip file'
        href={downloadUrl(URL_DOWNLOAD_DEAL_ZIP, { dealId })}
        onClick={onClickDownload}
      />
    </LayoutHeader>
    <Table columnTitles={['Type', 'Date of release', 'File']}>
      {documents.map((document, key) => (
        <Document key={key} document={document} {...{ onClickDownload, downloadUrl, dealId }} />
      ))}
    </Table>
  </>
)

export default DealDocuments
